import { Textarea as ChakraTextarea, type TextareaProps as ChakraTextareaProps, forwardRef } from "@chakra-ui/react";
import ResizeTextarea from "react-textarea-autosize";
import { type TypographyProps } from "@/components/essentials/typography";
import { injectTypographyVariant } from "@/components/essentials/typography/variant";
import { useMemo } from "react";
import { injectTextareaVariant } from "./variant";
import { scrollOnFocus } from "@/modules/utils/scroll-on-focus";

export interface AutoResizeTextareaProps extends ChakraTextareaProps {
  typography?: TypographyProps["variant"];
  isError?: boolean;
  minRows?: number;
}

export const AutoResizeTextarea = forwardRef<AutoResizeTextareaProps, "textarea">((props, ref) => {
  const {
    typography = {
      base: "sentence3",
      sm: "sentence3",
      md: "sentence2",
      lg: "sentence1",
      xl: "sentence1",
      "2xl": "sentence1",
    },
    isError,
    minRows,
    ...rest
  } = props;
  const typographyProps = useMemo(() => injectTypographyVariant(typography), [typography]);
  const { _focus, ...textareaVariant } = useMemo(() => injectTextareaVariant(isError), [isError]);
  return (
    <ChakraTextarea
      minH="unset"
      overflow="hidden"
      w="100%"
      resize="none"
      ref={ref}
      minRows={minRows ?? 5}
      _hover={{}}
      _focus={{ ..._focus, ...rest._focus }}
      _placeholder={{ textColor: "mono.dark.26" }}
      as={ResizeTextarea}
      onFocus={scrollOnFocus}
      {...typographyProps}
      {...textareaVariant}
      {...rest}
    />
  );
});
